import {
  format,
  addHours,
  addSeconds,
  fromUnixTime,
  set,
  parse,
  startOfDay,
  endOfDay
} from 'date-fns'
import { th } from 'date-fns/locale'
import differenceInMinutes from 'date-fns/differenceInMinutes'
import eachDayOfInterval from 'date-fns/eachDayOfInterval'

export const formatNumber = (num) => {
  if (num === undefined) return ''
  if (!num) return num
  const tempNum = num.toString().split('.')
  return `${tempNum[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${tempNum[1] ? '.'+tempNum[1] : ''}`
}

export const formatNumberV2 = (num) => {
  if (num === undefined) return ''
  if (!num) return num
  return Number(num).toLocaleString('en', { 
    minimumFractionDigits: 0,
    maximumFractionDigits: 3 
  })
}

export const formatNumberDigit = (num, digit) => {
  if (num === undefined) return ''
  if (!num) return num
  return Number(num).toLocaleString('en', { 
    minimumFractionDigits: 0,
    maximumFractionDigits: digit 
  })
}

export const formatDuration = (second) => {
  var currentDate = addSeconds(new Date(0), second)
  return format(addHours(currentDate, -7), 'HH:mm')
}

export const getMinuteTime = (second) => {
  return Math.ceil(second / 60)
}

export const getMinuteTimeV2 = (startedTime, finishedTime) => {
  if (!startedTime || !finishedTime) return 0

  const finishDate = new Date(finishedTime * 1000)
  finishDate.setSeconds(0)
  const startDate = new Date(startedTime * 1000)
  startDate.setSeconds(0)

  return differenceInMinutes(finishDate, startDate)
}

export const formatDurationHHmmss = (second) => {
  var currentDate = addSeconds(new Date(0), second)
  return format(addHours(currentDate, -7), 'HH:mm:ss')
}

export const unitDuration = (second) => {
  // return second < 3600 ? 'นาที' : 'ชั่วโมง'
  return 'นาที'
}

export const getISOStartOfDate = (dateS) => {
  const startOfDayLocal = startOfDay(dateS);
  return startOfDayLocal.toISOString();
}

export const getISOEndOfDate = (dateE) => {
  const endOfDayLocal = endOfDay(dateE);
  return endOfDayLocal.toISOString();
}

export const isDiffDay = (unixStart, unixEnd) => {
  if (!unixStart || !unixEnd) return false

  const startDate = new Date(unixStart * 1000)
  const endDate = new Date(unixEnd * 1000)
  return startDate.getDay() !== endDate.getDay()
}

export const getBeforeMidnight = (startUnix) => {
  const d = fromUnixTime(startUnix)
  const beforeMid = set(d, { hours: 23, minutes: 59, seconds: 59 })
  return Math.round(beforeMid.getTime() / 1000)
}


export const getMidnight = (endUnix) => {
  const d = fromUnixTime(endUnix)
  const mid = set(d, { hours: 0, minutes: 0, seconds: 0 })
  return Math.round(mid.getTime() / 1000)
}

export const formatDate = (yyyyMMdd) => {
  if (!yyyyMMdd) return ''
  return format(parse(yyyyMMdd, 'yyyy-MM-dd', new Date()), 'dd.MM.yyyy')
}

export const formatDateFromUnix = (unixTimestamp) => {
  if (!unixTimestamp) return '-'
  return format(new Date(unixTimestamp * 1000), 'dd.MM.yyyy HH:mm')
}

export const formatDateObject = (date, formatStr = 'yyyy-MM-dd') => {
  if (!date) return ''
  return format(date, formatStr)
}

export const ceil2Decimal = (num) => {
  return Number(num.toFixed(3))
}

export const formatDateISO = (isoDateTime, withoutSec) => {
  if (!isoDateTime) return ''
  if (withoutSec) return format(addHours(parse(isoDateTime, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", new Date()), 7), 'dd.MM.yyyy HH:mm')
  return format(addHours(parse(isoDateTime, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", new Date()), 7), 'dd.MM.yyyy HH:mm:ss')
}

export const formatDateISOToTh = (isoDateTime) => {
  if (!isoDateTime) return ''
  return format(addHours(parse(isoDateTime, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", new Date()), 7), 'd MMM yyyy HH:mm', {
    locale: th
  })
}

export const getDates = (start, end) => {
  if (!start) return []
  if (!end) {
    return [format(start, 'yyyy-MM-dd')]
  }

  return eachDayOfInterval({
    start, end
  }).map(d => format(d, 'yyyy-MM-dd'))
}

export const formatDateUnixToTh = (unixDateTime) => {
  if (!unixDateTime) return ''
  const d = fromUnixTime(unixDateTime)
  return format(d, 'd MMM yyyy HH:mm', {
    locale: th
  })
}

export const formatMonthObject = (date, formatStr = 'yyyy-MM') => {
  if (!date) return ''
  return format(date, formatStr)
}